import React, { Component } from "react";
import { Link } from "@reach/router";
import "../styles/Nav.css";
import Logo from './Images/wazito-logo.jpg'

export class Nav extends Component {
  render() {
    return (
      <div className="Nav-page">
        <div className="logo">
          <img src={Logo} alt="Nothing to display" />
          <h2>wazito</h2>
        </div>
        <div className="Nav">
          <Link to="/" className="nav-link">
            HOME
          </Link>
          <Link to="/about" className="nav-link">
            ABOUT US
          </Link>
          <Link to="/services" className="nav-link">
            SERVICES
          </Link>
          <Link to="/gallery" className="nav-link">
            GALLERY
          </Link>
          <Link to="/contacts" className="nav-link">
            CONTACT US
          </Link>
        </div>
      </div>
    );
  }
}

export default Nav;
